import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { ItemType } from '../../../models/ViewModels/RecordCatalogViewModel'
import { RecordPastMedicalHistoryType } from '../../../models/ViewModels/RecordViewModel'
import TextBox from '../../../share/Elements/Textboxs/Textbox'

const RecordPastMedicalHistory = ({
  catalog,
  item,
  onItemChange,
}: {
  catalog?: Array<ItemType<number>>
  item?: RecordPastMedicalHistoryType
  onItemChange: (updatedItem: RecordPastMedicalHistoryType) => void // A function to handle item changes
}) => {
  const onChange = (event: React.ChangeEvent<HTMLSelectElement>, catalog) => {
    // Create a copy of the items array (if it exists)
    const updatedItems = item?.items ? [...item.items] : []

    const itemIndex = updatedItems.findIndex(
      (obj) => obj.pastmedicalHistoryId === catalog.id
    )

    if (itemIndex !== -1) {
      updatedItems[itemIndex].value = event.target.value
    } else {
      updatedItems.push({
        pastmedicalHistoryId: catalog.id,
        value: event.target.value,
        showAbstract: item?.isShowAbstract!,
      })
    }

    // Call the onItemChange function with the updated item
    onItemChange({
      ...item,
      items: updatedItems,
      isShowAbstract: false,
    })
  }
  return (
    <>
      <div className='m-1 '>
        <div className='grid grid-cols-2 items-center'>
          <div className='mr-3 mb-2'>
            <label className='text-secondary'>نمایش در پرونده</label>
            <input
              type='checkbox'
              className='m-1.5'
              checked={item?.isShowAbstract || false}
              onChange={() =>
                onItemChange({
                  ...item,
                  isShowAbstract: !item?.isShowAbstract!,
                  items: item?.items!,
                })
              }
            ></input>
          </div>
        </div>
        <div className='grid grid-cols-1 gap-4 m-3 '>
          {catalog?.map((n, i) => (
            <TextBox
              className='ml-4'
              debounceTime={0}
              innerText={n.title}
              value={
                item?.items?.find((obj) => obj.pastmedicalHistoryId === n.id)
                  ?.value || ''
              }
              key={i}
              Type={TextBoxTypeEnum.Text}
              onChange={(e) => onChange(e, n)}
            />
          ))}
        </div>
      </div>
    </>
  )
}

export default RecordPastMedicalHistory
